@import url('./resets.css');
@import url('./variables/primitives.css');
@import url('./variables/semantic.css');

:host {
    font-family: var(--primary-font-family);
    font-optical-sizing: var(--primary-optical-sizing);
    font-weight: normal;
    
}